/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminProductListImage
 */
export interface AdminProductListImage {
    /**
     * 
     * @type {boolean}
     * @memberof AdminProductListImage
     */
    isPrimary?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AdminProductListImage
     */
    originalPath: string;
    /**
     * 
     * @type {string}
     * @memberof AdminProductListImage
     */
    thumbnailPath: string;
}

export function AdminProductListImageFromJSON(json: any): AdminProductListImage {
    return AdminProductListImageFromJSONTyped(json, false);
}

export function AdminProductListImageFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminProductListImage {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'isPrimary': !exists(json, 'isPrimary') ? undefined : json['isPrimary'],
        'originalPath': json['originalPath'],
        'thumbnailPath': json['thumbnailPath'],
    };
}

export function AdminProductListImageToJSON(value?: AdminProductListImage | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'isPrimary': value.isPrimary,
        'originalPath': value.originalPath,
        'thumbnailPath': value.thumbnailPath,
    };
}

